import styled from '@emotion/styled';
import Text from '~/components/Text';
import Gap from '~/components/Gap';

const EmptyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
`;

const EmptyEmailList = () => {
  return (
    <EmptyContainer>
      <Text variant="h3" color="textSecondary">
        No emails sent yet
      </Text>
      <Gap t={8} />
      <Text variant="body" color="textSecondary">
        When you send invoices or estimates to clients, they'll appear here.
      </Text>
    </EmptyContainer>
  );
};

export default EmptyEmailList;
